/**
 * 旅行MBTI 診断結果キャラクター画像（透過処理済み・土田様提供）
 * 正本: https://drive.google.com/drive/folders/1EVFRJmkj9N8vI7AeIhwaigV_exs7qcuw
 * 更新: node scripts/download-mbti-characters-transparent.mjs
 */
import imageMap from './mbtiCharacterImageMap.json';
import type { MbtiCode } from '@/data/diagnosisResults/types';

type MapEntry = {
  code: MbtiCode;
  publicPath: string;
};

const paths = Object.fromEntries(
  (imageMap.mapping as MapEntry[]).map((entry) => [entry.code, entry.publicPath]),
) as Record<MbtiCode, string>;

export const MBTI_CHARACTER_IMAGES: Record<MbtiCode, string> = paths;

export function getMbtiCharacterImage(code: string): string {
  const key = code.toUpperCase() as MbtiCode;
  return MBTI_CHARACTER_IMAGES[key] ?? MBTI_CHARACTER_IMAGES.PALE;
}
